<script>
  import GreenChip from "../../components/chips/base/GreenChip.svelte";
  import BlueChip from "../../components/chips/base/BlueChip.svelte";
  import RedChip from "../../components/chips/base/RedChip.svelte";
  import OrangeChip from "../../components/chips/base/OrangeChip.svelte";

  export let status
</script>

{#if status === "cancelled"}
  <OrangeChip title="キャンセル" />
{/if}
{#if status === "failed"}
  <RedChip title="失敗" />
{/if}
{#if status === "timeout"}
  <RedChip title="タイムアウト" />
{/if}
{#if status === "executing"}
  <BlueChip title="実行中" />
{/if}
{#if status === "executed"}
  <GreenChip title="成功" />
{/if}

